import { render } from "./action.html?vue&type=template&id=d3cdb8d8&scoped=true&ts=true"
import script from "./action.ts?vue&type=script&lang=ts"
export * from "./action.ts?vue&type=script&lang=ts"

import "./action.scss?vue&type=style&index=0&id=d3cdb8d8&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3cdb8d8"]])

export default __exports__